import "@mantine/core/styles.css";
import "leaflet/dist/leaflet.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./context/AuthContext";
import { Notifications } from "@mantine/notifications";
import { GlobalStyle, theme, breakpoints } from "./theme";
import { ThemeProvider } from "styled-components";
import AppRoutes from "./routes/AppRoutes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <GlobalStyle />
      {/*
        Mantine'in duyarlı prop'ları (ör. h={{ base: "auto", md: 320 }}) kendi
        kırılım noktalarına bakıyor. Varsayılan md 62em (992px) — bizim compact
        eşiğimiz 1024px. İkisi ayrı kalırsa 992-1024 arasında kabuk bir moda,
        içerik başka moda geçiyor. Tek kaynak: theme.ts.
      */}
      <MantineProvider
        theme={{
          breakpoints: {
            xs: "36em",
            sm: `${breakpoints.mobile / 16}em`,
            md: `${breakpoints.compact / 16}em`,
            lg: "75em",
            xl: "88em",
          },
        }}
      >
        <ThemeProvider theme={theme}>
          <Notifications />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ThemeProvider>
      </MantineProvider>
    </AuthProvider>
  </React.StrictMode>
);
